import type { RootState } from "types";

export const getCurrentSearchTerm = (state: RootState) => state.domains.search.currentSearchTerm;

export const getSearchSectionVisibility = (state: RootState) => state.domains.search.sectionVisibility;

export const getInteractiveDataSearchHasNextPage = (state: RootState) =>
  state.domains.search.interactiveData.hasNextPage;

export const getPublicationsSearchHasNextPage = (state: RootState) => state.domains.search.publications.hasNextPage;

export const getVideosSearchHasNextPage = (state: RootState) => state.domains.search.videos.hasNextPage;

export const getIsInteractiveDataSearchCached = (state: RootState) =>
  getCurrentSearchTerm(state) in state.domains.search.interactiveData.idsForQuery;

export const getIsPublicationsSearchCached = (state: RootState) =>
  getCurrentSearchTerm(state) in state.domains.search.publications.idsForQuery;

export const getIsTopicsSearchCached = (state: RootState) =>
  getCurrentSearchTerm(state) in state.domains.search.topics.idsForQuery;

export const getIsVideosSearchCached = (state: RootState) =>
  getCurrentSearchTerm(state) in state.domains.search.videos.idsForQuery;

export const getInteractiveDataSearchIsPending = (state: RootState) => state.domains.search.interactiveData.isPending;

export const getPublicationsSearchIsPending = (state: RootState) => state.domains.search.publications.isPending;

export const getTopicSearchIsPending = (state: RootState) => state.domains.search.topics.isPending;

export const getVideosSearchIsPending = (state: RootState) => state.domains.search.videos.isPending;

export const getSearchIsPending = (state: RootState) =>
  getInteractiveDataSearchIsPending(state) ||
  getPublicationsSearchIsPending(state) ||
  getTopicSearchIsPending(state) ||
  getVideosSearchIsPending(state);

export const getSearchHasResults = (state: RootState) => {
  const { currentSearchTerm } = state.domains.search;
  return (
    currentSearchTerm.length > 0 &&
    (!!state.domains.search.topics.idsForQuery[currentSearchTerm]?.length ||
      !!state.domains.search.publications.idsForQuery[currentSearchTerm]?.length ||
      !!state.domains.search.videos.idsForQuery[currentSearchTerm]?.length ||
      !!state.domains.search.interactiveData.idsForQuery[currentSearchTerm]?.length)
  );
};

export const getInteractiveDataSearchResults = (state: RootState) =>
  state.domains.search.interactiveData.idsForQuery[getCurrentSearchTerm(state)];

export const getPublicationsSearchResults = (state: RootState) =>
  state.domains.search.publications.idsForQuery[getCurrentSearchTerm(state)];

export const getTopicSearchResults = (state: RootState) =>
  state.domains.search.topics.idsForQuery[getCurrentSearchTerm(state)];

export const getVideosSearchResults = (state: RootState) =>
  state.domains.search.videos.idsForQuery[getCurrentSearchTerm(state)];
